var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileCards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9569 21.0037H5.0431C3.93764 21.0037 3.04227 20.1084 3.04227 19.0029V7.99833C3.04227 6.89287 3.93764 5.9975 5.0431 5.9975H18.9569C20.0624 5.9975 20.9577 6.89287 20.9577 7.99833V19.0029C20.9577 20.1084 20.0614 21.0037 18.9569 21.0037Z",
    stroke: "#374151",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.99875C13.3816 8.99875 14.501 10.1182 14.501 11.4998C14.501 12.8814 13.3816 14.0008 12 14.0008C10.6184 14.0008 9.49895 12.8814 9.49895 11.4998C9.49895 10.1182 10.6184 8.99875 12 8.99875",
    stroke: "#374151",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5019 18.0025C16.3708 17.6734 16.1677 17.3772 15.9076 17.1361V17.1361C15.4684 16.728 14.8932 16.5019 14.293 16.5019C13.2925 16.5019 10.7075 16.5019 9.70704 16.5019C9.10679 16.5019 8.53255 16.729 8.09237 17.1361V17.1361C7.83226 17.3772 7.62918 17.6734 7.49812 18.0025",
    stroke: "#374151",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77899 5.9975V4.99708C4.77899 3.89162 5.67436 2.99625 6.77982 2.99625H17.2192C18.3246 2.99625 19.22 3.89162 19.22 4.99708V5.9975",
    stroke: "#374151",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCards);
export default __webpack_public_path__ + "static/media/profile_cards.b755516e.svg";
export { ForwardRef as ReactComponent };